<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      row-key="id"
      lazy
      height="280"
      :load="toggleMethod"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :cell-style="{ padding: '3px' }"
      :header-cell-style="{ padding: '3px' }"
      style="width: 100%; font-size: 12px"
    >
      <el-table-column label="RM" width="120" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.asmUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.asmUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="DM" width="120" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.dsmUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.dsmUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="MR" width="120" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.mrUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.mrUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="MR已填写人数" width="110" align="center">
        <template slot-scope="scope">
          <div class="ellipsis">{{ scope.row.fillInNum }}/{{ scope.row.totalMrNum }}</div>
        </template>
      </el-table-column>
      <el-table-column label="是否已确认" width="90" align="center">
        <template slot-scope="scope">
          <div class="ellipsis">{{ scope.row.confirmName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预估数量(标准)" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.estimateQtyStandard | numberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="指标数量" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.targetQty | numberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预估达成(数量)" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.estimateAchievement | numberFormat(false, true) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预估金额" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.estimateAmount | numberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="指标金额" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.targetAmount | numberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预估达成(金额)" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.estimateAchievementAmount | numberFormat(false, true) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      small
      layout="prev, pager, next, total"
      :total="total"
      :page-size="ipagination.pageSize"
      @current-change="handleTableChange"
    ></el-pagination>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {}
    },
    ipagination: {
      type: Object,
      default: () => {}
    },
    total: {
      type: Number,
      default: 0
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    toggleMethod(v, treeNode, resolve) {
      let params //查询条件
      let url
      if (v.level == 1) {
        url = '/sip/estimate/overview/fillInStatisticsByDm'
        params = {
          asmTerritoryId: v.asmTerritoryId,
          ...this.params
        }
      } else if (v.level == 2) {
        url = '/sip/estimate/overview/fillInStatisticsByMr'
        params = {
          asmTerritoryId: v.asmTerritoryId,
          dsmTerritoryId: v.dsmTerritoryId,
          ...this.params
        }
      }
      postAction(url, params).then(res => {
        if (res.success) {
          resolve(
            res.result.map(i => {
              return {
                ...v,
                ...i,
                id: i.level == 2 ? i.dsmTerritoryId : i.level == 3 ? i.mrTerritoryId : ''
              }
            })
          )
        }
      })
    },
    handleTableChange(pagination) {
      this.$emit('change', pagination)
    }
  }
}
</script>

<style lang="less" scoped>
// 修复带展开符号列会换行问题
/deep/ tbody {
  tr {
    td:first-child {
      .cell {
        display: flex;
      }
    }
  }
}
/deep/ .el-pagination {
  width: 100%;
  overflow-x: auto;
  li {
    margin: 0 3px !important;
  }
  .btn-prev {
    margin: 0 3px !important;
  }
  .btn-next {
    margin: 0 3px !important;
  }
  .btn-quickprev {
    margin: 0px !important;
  }
  .btn-quicknext {
    margin: 0px !important;
  }
}
.ellipsis {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.ellipsis-1 {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}
</style>

<style lang="less">
.tooltip-class {
  font-size: 12px;
  color: #606266;
  border: 1px solid #fff !important;
  box-shadow: 0 0 5px #ccc;
}
</style>
